import React, { useState } from "react";
import styles from "../index.module.scss";
import { CircularProgress } from "@material-ui/core";

const DownloadDocuments = (props) => {
  const { row, getDocumentList, docListLoader, uniqueId } =
    props;
  const [error, setError] = useState("");

  const handleClick = (row) => {
    setError(getDocumentList(uniqueId, row.original.assignId, row.original));
  };
  return (
    <div style={{ textAlign: "center" }}>
      {docListLoader === row.original.assignId ? (
        <CircularProgress />
      ) : (uniqueId === "profilePhoto" && row.original.profile.profilePhoto) ||
        (uniqueId === "tenthMarksheet" &&
          row.original.formData?.tenthMarksheet) ||
        (uniqueId === "twelfthMarksheet" &&
          row.original.formData?.twelfthMarksheet) ||
        (uniqueId === "exServicemanIdFromTheZilaSainikBoard" &&
          row.original.formData?.exServicemanIdFromTheZilaSainikBoard) ||
        (uniqueId === "dischargeBookCopy" &&
          row.original.formData?.dischargeBookCopy) ||
        (uniqueId === "uploadYourGraduationPostGraduationMarksheet" &&
          row.original.formData
            ?.uploadYourGraduationPostGraduationMarksheet) ? (
        <button
          className={styles.workerName}
          type="button"
          style={{ fontSize: "16px !important" }}
          onClick={() => {
            handleClick(row);
          }}
        >
          Downloads
        </button>
      ) : (
        <div>No documents</div>
      )}
    </div>
  );
};

export default DownloadDocuments;
